<template>
  <v-app id="app">
    <NavigationSystem />
    <v-main class="content">
      <router-view />
    </v-main>
    <FooterMenu />
  </v-app>
</template>

<script>
// import { RouterLink, RouterView } from "vue-router";
import { adminStore } from '@/stores/adminstore.js'
import { userStore } from '@/stores/userstore.js'
import { loginStore } from '@/stores/loginstore.js'
import { imageStore } from '@/stores/imagestore.js'

import FooterMenu from '@/components/menues/FooterMenu.vue'
import update from './mixins/update'

/*
import { registerSW } from 'virtual:pwa-register'
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    updateExists = true
  },
  onOfflineReady() {}
})
*/
import NavigationSystem from '@/components/menues/NavigationSystem.vue'
export default {
  name: 'App',
  components: {
    FooterMenu,
    //  DoLogIn: () => import('@/components/menues/DoLogIn.vue'),
    NavigationSystem
    // PWABadge: () => import('@/components/misc/PWABadge.vue')
  },
  mixins: [update],
  beforeRouteEnter(to, from) {
    this.$info('------- APP VUE BEFORE ENTER -------- (%s) (%s)', to, from)
  },
  setup() {
    // const adminStore = adminStore()
    return {
      // you can return the whole store instance to use it in the template
      // adminStore
    }
  },
  data() {
    return {
      errorCapture: false,
      snackbarTimeout: -1,
      isOnline: false,
      isOffline: false,
      hasUpdate: false,
      incrementSeconds: 0
    }
  },
  beforeMount() {
    console.log('APP BEFORE MOUNT <<<<<<<<<<<<< (%s)', location.hostname)
    let aStore = adminStore()
    let uStore = userStore()
    let lStore = loginStore()
    let iStore = imageStore()
    aStore.$reset()
    uStore.$reset()
    lStore.$reset()
    iStore.$reset()
    let serverUrl =
      import.meta.env.VITE_MEMAS_SERVER_PROD ||
      localStorage.getItem('memasserver')
    // let registryUrl = localStorage.getItem('memasregistry') || ''
    var localLang = navigator.language || navigator.userLanguage
    let userLang = localStorage.getItem('lang') || localLang
    console.info(
      'BROWSER LANG IS  (%s) (%s) (%s)',
      userLang.split('-').length,
      userLang,
      localLang
    )
    if (userLang.split('-').length > 1) {
      userLang = ''
    }
    let langComponents = localLang.split('-')
    console.info(
      'LANG COMPONENTS (%s) (%s) (%j)',
      langComponents.length,
      langComponents[0],
      langComponents
    )
    if (langComponents.length > 1 && userLang === '') {
      console.log('LANG COMPONENTS LENGTH > 1')
      userLang = langComponents[0].toLowerCase()
    }
    console.log('USER LANG (%s) (%s)', localLang, userLang)
    console.info(
      'BROWSER LANG IS (%s) (%s) (%j)',
      localLang,
      userLang,
      langComponents
    )
    aStore.setLang(userLang)
    localStorage.setItem('lang', userLang)
    this.$root.$i18n.locale = userLang
    this.$i18n.locale = userLang
    this.$date.locale(userLang)

    // @todo fix set to nothing...
    if (location.hostname === 'adminweb.eu') {
      aStore.setServername(import.meta.env.VITE_MEMAS_SERVER_PROD)
      serverUrl = import.meta.env.VITE_MEMAS_SERVER_PROD
      //  } else if (os.hostname() === 'memas-adminweb.ataa.no') {
    } else if (location.hostname === 'stage.adminweb.eu') {
      aStore.setServername(import.meta.env.VITE_MEMAS_SERVER_PROD)
      serverUrl = import.meta.env.VITE_MEMAS_SERVER_PROD
    } else if (location.hostname === 'localhost') {
      console.log('WE HAVE LOCALHOST (%s)', location.hostname)
      aStore.setServername(import.meta.env.VITE_MEMAS_SERVER_LOCAL)
      serverUrl = import.meta.env.VITE_MEMAS_SERVER_LOCAL
    }
    aStore.setServerUrl(serverUrl)
    const currentPath = window.location.pathname || '/'
    const isAuthCallbackPath =
      currentPath === '/mscallback' ||
      currentPath === '/callback' ||
      currentPath === '/googlecallback'
    aStore
      .addRegistryUrl()
      .then(() => {
        // During app bootstrap, prefer URL path over this.$route (route may not be resolved yet)
        if (
          currentPath === '/' &&
          !isAuthCallbackPath &&
          !sessionStorage.getItem('ms_auth_in_progress')
        ) {
          this.$router
            .push({
              path: '/'
            })
            .catch(() => {})
        }
      })
      .catch((error) => {
        if (
          currentPath === '/' &&
          !isAuthCallbackPath &&
          !sessionStorage.getItem('ms_auth_in_progress')
        ) {
          this.$router
            .push({
              path: '/'
              //      path: '/Error'
            })
            .catch(() => {})
        }
      })

      if (location.hostname === 'adminweb.eu') {
        aStore.setEnvironment('prod')
      } else if (location.hostname === 'stage.adminweb.eu') {
        aStore.setEnvironment('stage')
      } else if (location.hostname === 'localhost') {
        aStore.setEnvironment('dev')
      }
  },
  mounted() {
    window.addEventListener('offline', () => {
      // Update your UI to reflect that there's no connection.
      console.warn('*** WARN *** we are OFFLINE !')
      this.snackbarTimeout = -1
      this.isOnline = false
      this.hasUpdate = false
      this.isOffline = true
    })
    window.addEventListener('online', () => {
      // Update your UI to reflect that the connection is back.
      console.warn('*** WARN *** we are back ONLINE !')
      this.incrementSeconds = 0
      this.snackbarTimeout = 8000
      this.isOffline = false
      this.hasUpdate = false
      this.isOnline = true
      this.countSeconds()
    })
    window.addEventListener('swUpdate', () => {
      // Update your UI to reflect that the connection is back.
      console.warn('*** WARN *** we have Update !')
      this.incrementSeconds = 0
      this.snackbarTimeout = 8000
      this.isOffline = false
      this.isOnline = false
      this.hasUpdate = true
      // this.countSeconds();
    })
  },
  methods: {
    countSeconds() {
      setInterval(() => {
        let sec = this.incrementSeconds + 1
        this.incrementSeconds = sec
      }, 130)
    },
    // https://vite-pwa-org.netlify.app/guide/prompt-for-update.html
    onNeedRefresh() {
      console.log('******* NEEED REFRESH ******* (app.vue)')
      this.updateExists = true
      //  updateSW()
    },
    onOfflineReady() {
      console.log('******** ON OFFLINE READY ******* (app.vue)')
    }
  }
}
</script>

<style scoped>
.content {
  margin-top: 2vh;
}
</style>
